import React, { useMemo } from 'react';
import { Container, Row, Col, Nav } from 'reactstrap';
import { useIntl } from 'react-intl';
import { IPage } from '@whitelabel/helpers/types';
import logo from '@whitelabel/media/logo.svg';
import { IUser } from '../../../helpers/types';
import { SITE_NAME } from '../../../helpers/constants';
import Disclaimer from '../Disclaimer';
import {
  StyledFooter,
  StyledSectionNav,
  StyledNavHeader,
  StyledBrandLogo,
  StyledNavItem,
  StyledNavLink,
} from './styled';
import messages from './messages';

interface IFooterLargeProps {
  disclaimer?: IPage;
  user?: IUser;
  hideFooterNav?: boolean;
}

const FooterLarge = ({ disclaimer, user, hideFooterNav }: IFooterLargeProps): JSX.Element => {
  const intl = useIntl();
  const items = useMemo(
    () => [
      { key: 'about', messageKey: 'aboutLink', path: '/about' },
      { key: 'claims', messageKey: 'claimsLink', path: '/claim' },
      { key: 'terms', messageKey: 'termsLink', path: '/terms' },
      { key: 'privacy-policy', messageKey: 'privacyLink', path: '/privacy-policy' },
      { key: 'help', messageKey: 'helpLink', path: '/help' },
      ...(user ? [] : [{ key: 'login', messageKey: 'loginLink', path: '/login' }]),
    ],
    [user],
  );

  return (
    <StyledFooter id="Footer" data-test-id="FooterLarge">
      {!hideFooterNav && (
        <StyledSectionNav data-test-id="FooterLarge-sectionNav">
          <Container>
            <Row>
              <Col xs={12} lg={6}>
                <StyledNavHeader>
                  <StyledBrandLogo data-test-id="FooterLarge-heading" src={logo} alt={SITE_NAME} />
                </StyledNavHeader>
                <Row tag={Nav} data-test-id="FooterLarge-nav">
                  {items.map(({ key, messageKey, path }) => (
                    <StyledNavItem key={key} data-test-id="FooterLarge-navItem">
                      <StyledNavLink
                        to={`/${intl.locale}${path}`}
                        data-test-id="FooterLarge-navLink"
                        data-analytics={`navbarFooter${messageKey}`}
                      >
                        {intl.formatMessage(messages[messageKey as keyof typeof messages])}
                      </StyledNavLink>
                    </StyledNavItem>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </StyledSectionNav>
      )}

      {disclaimer && <Disclaimer disclaimer={disclaimer} />}
    </StyledFooter>
  );
};

export default FooterLarge;
